<template>
  <div class="download-page" v-title data-title="APP下载"></div>
</template>

<script>
  import judgeClient from 'assets/js/judgeClient';
  import { btzx, xskt } from '../config';

  export default {
    name: 'webDownload',
    created() {
      const { name } = this.$route.params;
      if (name) {
        this.download(name);
      }
    },
    methods: {
      download(name) {
        const app = name === 'btzx' ? btzx : xskt;
        const ua = judgeClient();
        if (ua === 'Android') {
          window.location.href = app.androidUrl;
        } else if (ua === 'iOS') {
          window.location.href = app.iosUrl;
        } else {
          this.$toast('请用手机打开');
        }
      },
    },
  };
</script>
